export const Styles = {
   heightWithTopic:(window.innerHeight-267),
};
